var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-page" },
    [
      _c("b-container", [
        _c(
          "div",
          { staticClass: "errorContainer mx-auto" },
          [
            _c("h1", { staticClass: "errorCode" }, [_vm._v("404")]),
            _vm._v(" "),
            _c("p", { staticClass: "errorInfo" }, [
              _vm._v(
                "\n          Opps, it seems that this page does not exist.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "errorHelp mb-3" }, [
              _vm._v(
                "\n          If you are sure it should, search for it.\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "b-form",
              [
                _c(
                  "b-form-group",
                  [
                    _c("b-form-input", {
                      staticClass: "input-no-border",
                      attrs: { type: "text", placeholder: "Search Pages" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "a", to: "/app/extra/search" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "errorBtn",
                        attrs: { type: "submit", variant: "inverse" }
                      },
                      [
                        _vm._v("\n              Search "),
                        _c("i", {
                          staticClass: "fa fa-search text-warning ml-xs"
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("footer", { staticClass: "pageFooter" }, [
          _vm._v("\n      2019 © Sing App Vue Admin Dashboard Template.\n    ")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }